import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { oauthApplicationsRouter } from './routing/oauthApplicationsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { oauthApplicationsAccessControl } from './access-control/oauthApplicationsAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'oauth-applications',
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    partnerScoped: [oauthApplicationsRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Developer,
      attachToV2: NavEntryPoint.Developer,
      subNavItems: [
        {
          type: 'item',
          labelId: 'oauthApplicationsDomain.title',
          route: 'oauth-applications-list',
          accessControl: oauthApplicationsAccessControl,
          position: 3,
          positionNavV2: 3,
          inToolPermissions: [
            {
              slug: Permission.RetailerCredentialManagementView,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.RetailerCredentialManagementView,
            },
            {
              slug: Permission.RetailerCredentialManagementModify,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.RetailerCredentialManagementModify,
            },
          ],
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'oauth-applications-dashboard-tool',
  },
}

export default definition
